import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not yet converted to GTS }}\n\n{{outlet}}\n",{ moduleName: "garaje/pods/visitors/settings/template.hbs" })